import { render, staticRenderFns } from "./reviewer.vue?vue&type=template&id=2e880102&scoped=true"
import script from "./reviewer.vue?vue&type=script&lang=js"
export * from "./reviewer.vue?vue&type=script&lang=js"
import style0 from "./reviewer.vue?vue&type=style&index=0&id=2e880102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e880102",
  null
  
)

export default component.exports